module.exports = __webpack_public_path__ + "img/ic_affinity.808b33ad.png";